/*
	Check that the event data is in this shape.
	{
		name: "getHeight",
		id: element.id
	}
*/
const checkEventData = (event) => {
  try {
    Object.prototype.hasOwnProperty.call(event, "data");
  } catch {
    return false;
  }
  try {
    Object.prototype.hasOwnProperty.call(event, "name");
  } catch {
    return false;
  }
  try {
    Object.prototype.hasOwnProperty.call(event, "id");
  } catch {
    return false;
  }
  let isObject = typeof event.data === "object";
  let nameIsGetHeight = event.data.name === "getHeight";
  let idIsSting = typeof event.data.id === "string";

  return isObject && nameIsGetHeight && idIsSting;
};

export default checkEventData;
